import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useSortLlm = () => {
  const {
    data: isSorted,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const sortLlm = async (orderedLlmNames: string[]) => {
    await call("/admin/llm/sort", "PUT", undefined, { orderedLlmNames });
  };

  return {
    sortLlm,
    isSorted,
    isLoading,
    isFailed,
  };
};
